
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Dispute } from '../../global/models'
import { ListAction, ListColumn } from '../../global/components/List/Table.vue'
import SimpleList from '../../global/components/SimpleList.vue'
import { ListFilter } from '../../global/components/List/favourites'
import { prettyDateTime, toTitleCase } from '../../global/functions/util'

@Component({
  components: { SimpleList }
})
export default class ActiveJobsCard extends Vue {
  private headers: ListColumn<Dispute>[] = [
    { text: 'Customer', value: 'customerName', type: 'string' },
    { text: 'Status', value: 'status', type: 'string', display: (status) => toTitleCase(status as string) },
    { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
    { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
  ]

  private get columns() {
    return ['customerName', 'status', 'created', 'updated']
  }

  private loading = false

  get agencyId() {
    return this.$store.state.auth.agencyId
  }

  get list () {
    return this.$refs.list as SimpleList<Dispute>
  }

  get filters(): ListFilter[] {
    return [
      { field: 'status', operator: 'ne', value: 'resolved' },
      { field: 'status', operator: 'ne', value: 'rejected' },
      { field: 'status', operator: 'ne', value: 'withdrawn' },
      { field: 'status', operator: 'ne', value: 'adjudicated' }
    ]
  }

  private get actions(): ListAction<Dispute>[] {
    return [
      { text: 'View', method: dispute => this.view(dispute) }
    ]
  }

  private view(dispute: Dispute) {
    this.$router.push({ name: 'disputes-read', params: { id: dispute.id.toString() }})
  }

  public refresh () {
    this.list.updateResults()
  }
}
